var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var vein = require('veinjs');
var srcset = require('srcset');

function LoadImages() {
  this.init();
}

LoadImages.prototype = {
  init: function() {
    var elementsToLoad = document.querySelectorAll('[data-bg-img]:not(.bg-load)');

    for(var i = 0; i < elementsToLoad.length; i++) {
      var el = elementsToLoad[i];
      this.initBackground(el);
    }
  },
  initBackground: function(el) {
    el.classList.add('bg-load');

    var name = el.getAttribute('data-bg-img');
    var selector = '[data-bg-img="'+name+'"]';

    var sources = srcset.parse(el.getAttribute('data-bg-srcset'));
    var activeSource = '';

    var widths = $.map(sources, function(source, index) {
      return source.width;
    });

    var smallestWidth = Math.min.apply(this, widths);

    for(var i = 0; i < sources.length; i++) {
      var source = sources[i];

      if(source.width) {
        var targets = {};
        targets['@media (min-width: '+source.width+'px)'] = [selector];

        var target = [targets];
      } else {
        var targets = {};
        targets['@media (max-width: '+(smallestWidth - 1)+'px)'] = [selector];

        var target = [targets];
      }

      vein.inject(target, {
        'background-image': 'url('+source.url+')'
      });

      if((source.width && window.innerWidth > source.width) || !source.width) {
        activeSource = source.url;
      }
    }

    var activeSourceImage = new Image();

    activeSourceImage.src = activeSource;

    if(activeSourceImage.complete) {
      $(el).addClass('bg-loaded');
    } else {
      $(activeSourceImage).one('load', function() {
        $(el).addClass('bg-loaded');
      });
    }
  }
}

module.exports = LoadImages;